import {
  Box,
  CircularProgress,
  Container,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";

export default function CategoriesBar({ onCategoryClick, selectedCategory }) {
  const categories = useSelector((s) => s?.categories?.data);
  const loading = useSelector((s) => s?.categories?.loading);

  return (
    <Box sx={{ backgroundColor: "background.secondary" }}>
      <Container maxWidth="xl" sx={{ py: 2, width: 1 }}>
        <Tabs
          variant="scrollable"
          scrollButtons="auto"
          indicatorColor="transparent"
        >
          <Tab
            value="all"
            sx={{
              p: 0,
              mr: 1.5,
              fontSize: 10,
              border: selectedCategory === "all" && "2px dashed #FF5D18",
              backgroundColor: selectedCategory === "all" && "#F9E4DB",
              borderRadius: "12px",
              width: "169px",
              height: "156px",
              pt: 0.5,
            }}
            onClick={() => onCategoryClick("all")}
            label={
              <Typography
                variant="body2"
                color={
                  selectedCategory === "all"
                    ? "text.primary"
                    : "text.darkSecondary"
                }
              >
                All
              </Typography>
            }
            icon={
              <Box>
                <img
                  loading="lazy"
                  src={"/images/home/categories/all.svg"}
                  alt="all"
                  style={{ maxWidth: "94px" }}
                />
              </Box>
            }
          />
          {categories?.map((tab) => (
            <Tab
              key={tab?.id}
              sx={{
                p: 0.5,
                mr: 1.5,
                fontSize: 10,
                backgroundColor: selectedCategory?.id === tab?.id && "#F9E4DB",
                border:
                  selectedCategory?.id === tab?.id && "2px dashed #FF5D18",
                borderRadius: "12px",
                pt: 0.5,
                width: "169px",
                height: "156px",
              }}
              value={tab?.id}
              onClick={() => onCategoryClick(tab)}
              label={
                <Typography
                  variant="body2"
                  color={
                    selectedCategory?.id === tab?.id
                      ? "text.primary"
                      : "text.darkSecondary"
                  }
                >
                  {tab?.name}
                </Typography>
              }
              icon={
                <Box>
                  <img
                    loading="lazy"
                    src={"/images/home/categories/film.svg"}
                    alt={tab?.title}
                    style={{ maxWidth: "94px" }}
                  />
                </Box>
              }
            />
          ))}
          {loading && <CircularProgress />}
        </Tabs>
      </Container>
    </Box>
  );
}
